export default "__VITE_ASSET__BqCNKb30__"